<template lang="pug">
.page
  section
    .max-width
      .row.vertical.center
        .col
          .logo-wrapper
            img.logo(src="../../assets/images/logo-white-text.svg")

        .col
          .form-wrapper
            form(@submit.prevent="submit")

              h1.primary-text Forgot Password

              //-AlertBox(v-if="error", type="danger", :text="error")
              div.form-field(:class="{error: $v.form.email.$error, 'error-required': !$v.form.email.required}")
                label
                  input(placeholder="Email Address", v-model="$v.form.email.$model", type="email")
                .error(v-if="errors.email") {{ errors.email }}

              div.form-field.no-margin
                button.button.primary-button(type="submit") Recover
        .col
          p.footer
            | Already have an account?&nbsp;
            router-link.link(:to="{name: 'login'}") Login!

</template>

<script>

  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'register',
    components: {
    },
    data () {
      return {
        errors: {},
        form: {
          email: '',
        }
      }
    },
    validations: {
      form: {
        email: {
          required
        },
      }
    },
    methods: {
      submit () {
        this.$v.$touch()
        if (this.$v.$invalid) {
          console.log('invalid')
        } else {
          this.$store.dispatch('user/forgotPassword', this.form).then(() => {
            this.$router.push({ name: 'ResetPassword' })
          }, response => {
            console.log(response)
            this.errors = response.data.errors
          })
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .page
    margin 0 auto

  .logo-wrapper
    margin-bottom 60px
    text-align center
    img
      max-width 521px
      +for_breakpoint(mobile)
        max-width 100%

  .form-wrapper
    background-color #fff
    border-radius $border-radius
    //margin-left $spacing-3
    margin-bottom 60px
    padding $spacing-3
    width 412px
    +for_breakpoint(mobile)
      width auto

    // h1
    //   font-size 22px
    //   text-align center
    //   margin-bottom 40px

    form
      margin 0 auto
      //max-width 400px
  p.footer
    color #fff
</style>
